<div *ngIf="em.showLoading" class="cssload-container">
  <div class="cssload-speeding-wheel"></div>
</div>
